import React from 'react';
import {useStaticQuery, graphql} from 'gatsby';
// import Image from "../image";
// import Img from 'gatsby-image'

const ServiceOne = (props) => {
    const aboutQueryData = useStaticQuery(graphql`
        query serviceData {
            allServiceJson {
                edges {
                    node {
                        id
                        number
                        title
                        description
                        readmoreButton
                        icon {
                            childImageSharp {
                                fluid(maxWidth: 1060, maxHeight: 600, quality: 100) {
                                    ...GatsbyImageSharpFluid_withWebp
                                    presentationWidth
                                    presentationHeight
                                }
                            }
                        }
                    }
                }
            }
        }
    `);
    const services = aboutQueryData.allServiceJson.edges;
    return (
        <>
            {services.map((data) => (
                <div className={props.column} key={data.node.id}>
                    <div className={`service ${props.serviceStyle}`}>
                        <div className="inner">
                            <div className="number">
                                <span>{data.node.number}</span>
                                {/* <img src={data.node.number} width="40"/> */}
                            </div>
                            <div className="content">
                                <h3 className="title">{data.node.title}</h3>
                                <p className="description">{data.node.description}</p>
                                {/* <a className="readmore-btn" href="#service">{data.node.readmoreButton}</a> */}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}
export default ServiceOne
